const initialState = {
  orgName: "",
  orgOwner: {
    id: 0,
    login: "",
    email: "",
  },
}

export default function details(state = initialState, event) {
  switch (event.type) {
    default: {
      return state
    }

    case "UPDATE_ORG_NAME": {
      return {
        ...state,
        orgName: event.orgName,
      }
    }

    case "UPDATE_ORG_OWNER": {
      return {
        ...state,
        orgOwner: event.orgOwner,
      }
    }
  }
}
